import * as Sentry from "@sentry/vue";

export default function (app) {
    const sentryDSN = import.meta.env.VITE_SENTRY_DSN;
    if(sentryDSN){
    
        Sentry.init({
            app,
            dsn: sentryDSN,
            integrations: [
              Sentry.browserTracingIntegration(),
              Sentry.replayIntegration(),
            ],
            tracesSampleRate: 1.0,
            // Session Replay
            replaysSessionSampleRate: 1.0,
            replaysOnErrorSampleRate: 1.0
          });
    }
}

  
